module.exports = __webpack_public_path__ + "static/media/3.cf98980a.jpg";